import { AssociateManualFattureProjectRequest, CicloAttivoControllerApi, Configuration } from '@api/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';
import { AppToastService } from 'shared/design-system/components/app-toast/app-toast.service';

enum ActiveCycleActions {
  associateInvoicesAutomaticActiveCycle = '[ActiveCycle] Associate Invoices Automatic Active Cycle',
  associateInvoicesManualActiveCycle = '[ActiveCycle] Associate Invoices Manual Active Cycle',
  recalculateInvoicesAutomaticActiveCycle = '[ActiveCycle] Recalculate Invoices Automatic Active Cycle',
}

export const associateInvoicesAutomaticActiveCycle = createAsyncThunk<
  void,
  { fkRowFattura: string; projectId: number; idOrdine: number; allPrj: boolean },
  ThunkApiConfig
>(ActiveCycleActions.associateInvoicesAutomaticActiveCycle, async (payload, { dispatch, extra, getState }) => {
  try {
    await new CicloAttivoControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).associateAutomaticFattureProject(payload);
    AppToastService.success(`Invoice associated successfully`);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const associateInvoicesManualActiveCycle = createAsyncThunk<
  void,
  AssociateManualFattureProjectRequest,
  ThunkApiConfig
>(ActiveCycleActions.associateInvoicesManualActiveCycle, async (payload, { dispatch, extra, getState }) => {
  try {
    await new CicloAttivoControllerApi(getConfiguration(Configuration, extra, getState)).associateManualFattureProject(
      payload
    );
    AppToastService.success(`Invoice associated successfully`);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const recalculateInvoicesAutomaticActiveCycle = createAsyncThunk<
  void,
  { projectId: number; idOrdine: number },
  ThunkApiConfig
>(ActiveCycleActions.recalculateInvoicesAutomaticActiveCycle, async (payload, { dispatch, extra, getState }) => {
  try {
    await new CicloAttivoControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).ricolcolaAutomaticFattureProject(payload);
    AppToastService.success('Invoices recalculated successfully');
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});
